import Vue from 'vue';
import Vuex from 'vuex';

// Import vuex store modules
import user from './modules/user';
import * as types from './mutation-types';

Vue.use(Vuex);

/**
 * Export Vuex store with strict mode and
 * middleware depending on config.ENV.debug setting for current environment
 *
 * @type {Vuex}
 */
export const store = new Vuex.Store({
    modules: {
        user,
    },

    state: {
        selectedLocale: 'de',
        preloaderAxiosRequestScreen: false,
        steps: {
                '1': {
                    title: '1. ',
                    translationString: 'checkout2.mtelNumber',
                },
                '2': {
                    title: '2. ',
                    translationString: 'checkout2.mtelAccount',
                },
                '3': {
                    title: '3. ',
                    translationString: 'checkout2.personalInformation',
                },
                '4': {
                    title: '4. ',
                    translationString: 'checkout2.document',
                },
                '5': {
                    title: '5. ',
                    translationString: 'checkout2.shop',
                },
        }    
    },

    getters: {
        preloaderScreen: (state) => state.preloaderAxiosRequestScreen,
        steps: (state) => state.steps,
    },

    mutations: {
        /**
         * Set to true preloader screen
         * @param state
         */
        [types.TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE](state) {
            state.preloaderAxiosRequestScreen = true;
        },

        /**
         * Set to false preloader screen
         * @param state
         */
        [types.TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE](state) {
            state.preloaderAxiosRequestScreen = false;
        },
    },

    strict: false,
});
